// extracted by mini-css-extract-plugin
export default {"RelatedItemContainer":"index__RelatedItemContainer__pc_H0","RelatedContainerTitle":"index__RelatedContainerTitle__CoolJ","RelatedContainerItem":"index__RelatedContainerItem__BSOZF"};